import React from "react";
import SectionBezel from "components/SectionBezel";
import CheckoutPreview from "components/CheckoutPreview";

const CheckoutDetails = ({
  header,
  collapseImages,
  banner,
  actions,
  lineItems,
  discountItems,
  amountItems,
  taxItems,
  shippingItems,
  subscriptionScheduleItems
}) => {
  return (
    <SectionBezel header={header || "Checkout Summary"} action={actions[0]}>
      {lineItems.length > 0 ? (
        <CheckoutPreview
          banner={banner}
          collapseImages={collapseImages}
          lineItems={lineItems}
          discountItems={discountItems}
          amountItems={amountItems}
          taxItems={taxItems}
          shippingItems={shippingItems}
          subscriptionScheduleItems={subscriptionScheduleItems}
        />
      ) : (
        <div className="pv2">
          <div className="f6 lh-copy">
            Add some products to preview checkout.
          </div>
        </div>
      )}
    </SectionBezel>
  );
};

export default CheckoutDetails;
